import './style.css';
import { Experience } from '@/experience/Experience';

const canvas = document.querySelector<HTMLCanvasElement>('#webgl');
if (!canvas) throw new Error('ORVAE: #webgl canvas not found in document.');

const experience = new Experience({ canvas });
void experience.init();

// Expose for console inspection (e.g. `experience.performance.report()`).
(window as unknown as { experience: Experience }).experience = experience;

// Clean teardown on Vite HMR to avoid leaking WebGL contexts during development.
if (import.meta.hot) {
  import.meta.hot.dispose(() => experience.dispose());
}
